import { Link } from "react-router-dom";
import { ArrowLeft, Lock } from "@phosphor-icons/react";

export default function AccessDenied({ homeLink = "/", homeLabel = "Go Home" }) {
    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center p-16 text-center">
            <Lock size={48} weight="thin" className="text-fp-secondary mb-6" />
            <div className="font-sans text-[11px] uppercase tracking-[0.25em] text-fp-muted mb-3">Access Restricted</div>
            <h2 className="font-serif text-4xl text-fp-ink mb-3">You do not have permission for this view</h2>
            <p className="font-sans text-sm text-fp-secondary max-w-md mb-8">Your role scope does not include this section. Contact Corporate Finance if you believe you should have access.</p>
            <Link to={homeLink} className="inline-flex items-center gap-2 bg-fp-ink text-white px-6 py-2.5 font-sans text-sm hover:bg-fp-ink-hover transition-colors">
                <ArrowLeft size={14} /> {homeLabel}
            </Link>
        </div>
    );
}
